module.exports = __webpack_public_path__ + "static/media/essentra-logo-charcoal.9c6f2127.svg";